var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginFaceRecognition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.186,
    height: 42.186,
    viewBox: "0 0 296 296",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#fefefe;stroke-width:2.02223}.fil1{fill:#fefefe}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 148,
    r: 148,
    fill: "#201e1e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2749013834464"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M70 70v38h10V80h28V70zM226 70h-37v10h27v28h10zM226 226v-37h-10v27h-27v10zM70 226h38v-10H80v-27H70z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1 str0",
    x: 114,
    y: 105,
    width: 7.305,
    height: 19.016,
    rx: 233,
    ry: 233
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1 str0",
    x: 174,
    y: 105,
    width: 7.305,
    height: 19.016,
    rx: 233,
    ry: 233
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M136 153c6-1 9-6 9-10v-24c1-4 9-4 9 1v30c0 7-5 13-12 13-13 0-10-9-6-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 175c21 19 42 18 62-1",
    fill: "none",
    stroke: "#fefefe",
    strokeWidth: 10.615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFaceRecognition);
export default __webpack_public_path__ + "static/media/login-face-recognition.dd1c71e6fca0bdc0da157fccac23522b.svg";
export { ForwardRef as ReactComponent };